import Vue from 'vue';
import VueRouter from 'vue-router';
import Layout from '@/pages/Layout/index.vue';
import Home from '@/pages/Home/index.vue';
import AppManage from '@/pages/AppManage/index.vue';
import AccountAccess from '@/pages/AccountAccess/index.vue';
import Login from '@/pages/Login/index.vue';
import Register from '@/pages/Register/index.vue';
import DeveloperRegister from '@/pages/DeveloperRegister/index.vue';
import NotFound from '@/pages/NotFound.vue';

const routes = [
  {
    path: '/',
    component: Layout,
    children: [
      // 登录页面
      {
        path: '/login',
        name: 'Login',
        component: Login,
      },
      // 新账户自主注册
      {
        path: '/register',
        name: 'Register',
        component: Register,
      },
      // 已登录账户注册成为开发者
      {
        path: '/developer-register',
        name: 'DeveloperRegister',
        component: DeveloperRegister,
      },
      // 首页
      {
        path: 'home',
        name: 'home',
        component: Home,
      },
      // 应用管理
      {
        path: 'appmanage',
        name: 'AppManage',
        component: AppManage,
      },
      // 账号授权
      {
        path: 'accountaccess',
        name: 'AccountAccess',
        component: AccountAccess,
      },
      {
        path: '',
        redirect: '/home',
      },
    ],
  },
  {
    path: '/404',
    name: 'NotFound',
    component: NotFound,
  },
  {
    path: '/logout',
    redirect: '/login',
  },
  {
    path: '*',
    redirect: '/404',
  },
];

Vue.use(VueRouter);

const router = new VueRouter({
  mode: 'history',
  routes,
});

export default router;
